// South African EFT banks with their universal branch codes. South African
// banks issue a single "universal" branch code that routes to any branch, so the
// branch code is fully determined by the chosen bank — the agent never types it.
//
// NOTE: this drives the wizard dropdown only. The server re-validates the same
// list authoritatively at onboarding submit (artifacts/api-server/src/lib/saBanks.ts)
// — keep the two lists in sync.
export type SaBank = {
  name: string;
  universalBranchCode: string;
};

export const SA_BANKS: readonly SaBank[] = [
  { name: "Absa Bank", universalBranchCode: "632005" },
  { name: "African Bank", universalBranchCode: "430000" },
  { name: "Bank Zero", universalBranchCode: "888000" },
  { name: "Bidvest Bank", universalBranchCode: "462005" },
  { name: "Capitec Bank", universalBranchCode: "470010" },
  { name: "Capitec Business", universalBranchCode: "450105" },
  { name: "Discovery Bank", universalBranchCode: "679000" },
  { name: "First National Bank (FNB)", universalBranchCode: "250655" },
  { name: "Grindrod Bank", universalBranchCode: "584000" },
  { name: "Investec Bank", universalBranchCode: "580105" },
  { name: "Mercantile Bank", universalBranchCode: "450905" },
  { name: "Nedbank", universalBranchCode: "198765" },
  { name: "Sasfin Bank", universalBranchCode: "683000" },
  { name: "Standard Bank", universalBranchCode: "051001" },
  { name: "TymeBank", universalBranchCode: "678910" },
  { name: "Ubank", universalBranchCode: "431010" },
] as const;

export function branchCodeForBank(bankName: string | null | undefined): string {
  if (!bankName) return "";
  return SA_BANKS.find((b) => b.name === bankName)?.universalBranchCode ?? "";
}
